import React, {useEffect, useRef, useState} from 'react';
import cl from '../styles/CourseAddPage.module.css'
import camera from '../Assets/icons/photo_camera.svg'
import delete_icon from "../Assets/icons/delete.svg";
import clip from "../Assets/icons/clip.svg";
import MyButton from "../components/UI/MyButtons/MyButton";
import {useNavigate} from "react-router-dom";
import Service from "../API/Service";
import edit from "../styles/StudEditPage.module.css";
import arrow from "../Assets/icons/Vector.svg";
import code from "../Assets/icons/source_gray.svg";
import dep from "../Assets/icons/dashboard_customize.svg";
import teacher from "../Assets/icons/book.svg";
import calendar from "../Assets/icons/calendar_today.svg";
import PeriodModal from "../components/UI/PeriodModal/PeriodModal";
import {format, parseISO} from "date-fns";

const CourseAddPage = () => {
    const dropdownRef = useRef(null);
    const teacherDropdownRef = useRef(null);
    const navigate = useNavigate()
    const [modal, setModal] = useState(false);
    const [desc, setDesc] = useState("");
    const [courseName, setCourseName] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [teachers, setTeachers] = useState([]);
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [teacherDropdownOpen, setTeacherDropdownOpen] = useState(false);
    const [courseData, setCourseData] = useState({
        code: "",                  //done
        title: "",                 //done
        description: "",           //done
        teacherId: "",             //done
        departmentId: "",          //done
        startDate: "",             //
        endDate: "",               //
        syllabusMetadataLink: "",  //done
    })

    const maxLength = 500;

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await Service.getTables("departments");
                setDepartments(response?.data?.content || []);
            } catch (error) {
                console.error("Ошибка загрузки департаментов:", error);
            }
        };

        fetchDepartments();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current && !dropdownRef.current.contains(event.target) &&
                teacherDropdownRef.current && !teacherDropdownRef.current.contains(event.target)
            ) {
                setDropdownOpen(false);
                setTeacherDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleDepartmentSelect = async (id) => {
        setCourseData((prev ) => ({
            ...prev,
            departmentId: id,
        }));

        try {
            const response = await Service.getTeachersByDepId(id);
            setTeachers(response?.data?.content || []);
        } catch (error) {
            console.error("Ошибка загрузки учителей:", error);
        }

        setDropdownOpen(false);
    };

    const handleTeacherSelect = (id) => {
        setCourseData((prev) => ({
            ...prev,
            teacherId: id,
        }));
    };

    const create = async () => {
        try{
            const data = {
                code: courseData.code,
                title: courseData.title,
                description: courseData.description,
                teacherId: courseData.teacherId,
                departmentId: courseData.departmentId,
                startDate: startDate,
                endDate: endDate,
                syllabusMetadataLink: "courseData.syllabusMetadataLink", //TODO
                bannerMetadataLink: "AAAAAAAA"                          // TODO
            };
            await Service.createDep(data, "courses");
            alert("Курс успешно создан!");
            navigate(-1);
        } catch (e){
            alert("Ошибка при создании курса!");
        }
    }

    const handleDataChange = (field, value) => {
        setCourseData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleChange = (e) => {
        if (e.target.value.length <= maxLength) {
            setDesc(e.target.value);
            handleDataChange("description", e.target.value)
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.name.endsWith('.docx')) {
            setSelectedFile(file);
            handleDataChange("syllabusMetadataLink", file)
        }
    };

    const handleRemoveFile = () => {
        setSelectedFile(null);
    };

    const formatDate = (dateStr) => {
        return dateStr ? format(parseISO(dateStr), "dd.MM.yyyy") : '...';
    };

    return (
        <div className={cl.mainBlock}>
            <PeriodModal
                visible={modal}
                setVisible={setModal}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
            />
            <p className={cl.header}>
                Create new course
            </p>
            <div className={cl.content}>
                <div className={cl.thumbnail}>
                    <img
                        src={camera}
                        alt={"camera"}
                    />
                </div>
                <div
                    className={`${cl.courseName} ${courseName.length === 0 ? cl.empty : ''}`}
                    contentEditable
                    onInput={(e) => {
                        setCourseName(e.currentTarget.textContent);
                        handleDataChange("title", e.currentTarget.textContent)
                    }}
                    suppressContentEditableWarning={true}
                    placeholder={"Untitled course name"}
                />
                <div className={cl.param}>
                    <div className={cl.paramInfo}>
                        <img
                            src={code}
                            alt={"Code"}
                        />
                        Course code
                    </div>
                    <input
                        placeholder={"Empty"}
                        type={"text"}
                        onChange={(e) => {handleDataChange("code", e.target.value)}}
                    />
                </div>
                <div className={cl.param}>
                    <div className={cl.paramInfo}>
                        <img
                            src={dep}
                            alt={"Department"}
                        />
                        Department
                    </div>
                    <div className={edit.dropdown} ref={dropdownRef}>
                        <div className={edit.dropdownButton} onClick={() => setDropdownOpen(!dropdownOpen)}>
                            {departments.find(dep => dep.id === courseData.departmentId)?.name || "Select department"}
                            <img src={arrow} alt={"arrow"} className={dropdownOpen? edit.arrowDown : edit.arrowUp}/>
                        </div>
                        {dropdownOpen && (
                            <ul className={edit.dropdownMenu}>
                                {departments
                                    .filter(dep => dep.id !== courseData.departmentId)
                                    .map(dep => (
                                        <li
                                            key={dep.id}
                                            onClick={() => handleDepartmentSelect(dep.id)}
                                            className={edit.dropdownItem}
                                        >
                                            {dep.name}
                                        </li>
                                    ))}
                            </ul>
                        )}
                    </div>
                </div>
                <div className={cl.param}>
                    <div className={cl.paramInfo}>
                        <img
                            src={teacher}
                            alt={"Teacher"}
                        />
                        Teacher
                    </div>
                    <div className={edit.dropdown} ref={teacherDropdownRef}>
                        <div
                            className={edit.dropdownButton}
                            onClick={() => courseData.departmentId?setTeacherDropdownOpen(!teacherDropdownOpen) : setDropdownOpen(!dropdownOpen)}
                        >
                            {teachers.find(teach => teach.id === courseData.teacherId)?.name || "Select teacher"}
                            <img src={arrow} alt={"arrow"} className={teacherDropdownOpen? edit.arrowDown : edit.arrowUp}/>
                        </div>
                        {courseData.departmentId && teacherDropdownOpen && (
                            <ul className={edit.dropdownMenu}>
                                {teachers
                                    .filter(teach => teach.id !== courseData.teacherId)
                                    .map(teach => (
                                        <li
                                            key={teach.id}
                                            onClick={() => handleTeacherSelect(teach.id)}
                                            className={edit.dropdownItem}
                                        >
                                            {teach.name} {teach.surname}
                                        </li>
                                    ))}
                            </ul>
                        )}
                    </div>
                </div>
                <div className={cl.param}>
                    <div className={cl.paramInfo}>
                        <img
                            src={calendar}
                            alt="Calendar Icon"
                        />
                        Period
                    </div>
                    <input
                        placeholder={"Empty"}
                        type={"text"}
                        onClick={() => {setModal(true)}}
                        value={`${formatDate(startDate)} - ${formatDate(endDate)}`}
                        onChange={()=>{}}
                    />
                </div>
            </div>
            <div className={cl.description}>
                <p>
                    Course description
                </p>
                <div className={cl.textArea}>
                    <textarea
                        value={desc}
                        onChange={handleChange}
                        placeholder={"Text area"}
                    />
                    <span>
                        {desc.length} / {maxLength}
                    </span>
                </div>
            </div>
            <div className={cl.fileUploadPart}>
                <p>Upload syllabus/any other file if needed</p>
                <div
                    className={cl.uploadArea}
                >
                    {selectedFile ? (
                        <div className={cl.fileWrap}>
                            <div className={cl.fileInfo}>
                                {selectedFile.name}
                                <img src={delete_icon} onClick={handleRemoveFile} alt={"delete"}/>
                            </div>
                        </div>

                    ) : (
                        <label htmlFor="fileInput" className={cl.fileWrap}>
                            <input
                                type="file"
                                id="fileInput"
                                accept=".docx"
                                hidden
                                onChange={handleFileChange}
                            />
                            <img src={clip} alt={"clip"}/>
                            Upload list
                        </label>
                    )}
                </div>
            </div>
            <div className={"buttons"}>
                <MyButton
                    content={"Back"}
                    isBlue={false}
                    onClick={() => navigate(-1)}
                />
                <MyButton
                    content={"Create new course"}
                    isBlue={true}
                    onClick={create}
                />
            </div>
        </div>
    );
};

export default CourseAddPage;